import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import * as fromStore from "../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";

@Injectable()
export class BillingInfoResolver implements Resolve<any|null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getBillingInfoLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getBillingInfo)),
          first()
        )
        .subscribe((billingInfo: any) => {
          resolve(billingInfo);
        });
    });
  }
}
